<template>
  <div>
    <sign-document v-if="isSignDocumentSelected" :toggle-tab="toggleTab"></sign-document>
    <sign v-if="isSignSelected" :toggle-tab="toggleTab"></sign>
    <signFirel v-if="isSignSelectedFirel" :toggle-tab="toggleTab"></signFirel>
    <success v-if="isSuccess" :toggle-tab="toggleTab" />
    <DocumentNotAvailable v-if="isDocumentNotAvailable" :toggle-tab="toggleTab"/>
    <SignatureRejected v-if="isSignatureRejected" :toggle-tab="toggleTab"/>
    <SignedDocument v-if="isSignedDocument" :toggle-tab="toggleTab"/>
    <isSigning v-if="isSigning" :toggle-tab="toggleTab"/>
    <sign-simple v-if="isSignSimple" :toggle-tab="toggleTab" />
  </div>
</template>

<script>
import SignDocument from "@/views/pages/sign-document/components/SignDocument";
import Sign from "@/views/pages/sign-document/components/Sign";
import SignFirel from "@/views/pages/sign-document/components/SignFirel";
import Success from "@/views/pages/sign-document/components/Success";
import DocumentNotAvailable from "@/views/pages/sign-document/components/DocumentNotAvailable";
import SignatureRejected from "@/views/pages/sign-document/components/SignatureRejected";
import SignedDocument from "@/views/pages/sign-document/components/SignedDocument";
import isSigning from "@/views/pages/sign-document/components/isSigning";
import SignSimple from "@/views/pages/sign-document/components/SignSimple.vue";
export default {
  name: "SignDocumentPage",
  components: {
    SignDocument,
    Sign,
    SignFirel,
    isSigning,
    Success,
    DocumentNotAvailable,
    SignatureRejected,
    SignedDocument,
    SignSimple
  },
  data() {
    return {
      tabIndex: 1,
    }
  },
  computed: {
    isSignDocumentSelected() {
      return this.tabIndex === 1;
    },

    isSignSelected() {
      return this.tabIndex === 2;
    },

    isSuccess() {
      return this.tabIndex === 3;
    },

    isDocumentNotAvailable() {
      return this.tabIndex === 4;
    },

    isSignatureRejected() {
      return this.tabIndex === 5;
    },
    isSignedDocument() {
      return this.tabIndex === 6;
    },
    isSigning() {
      return this.tabIndex === 7;
    },
    isSignSelectedFirel() {
      return this.tabIndex === 8;
    },
    isSignSimple() {
      return this.tabIndex === 9;
    }
  },
  methods: {
    toggleTab(index) {
      this.tabIndex = index;
      this.scrollToTop();
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    updated() {
      this.scrollToTop();
    },
  }
}
</script>

<style scoped>

</style>
